module.exports = __webpack_public_path__ + "site/img/team_slogan_2x2.33764f90.jpg";